module.exports = __webpack_public_path__ + "media/images/undraw/matching/feedback-7ade603430199ab8fcb031cc3f470992.png";